import React from 'react'
import PropTypes from 'prop-types'

import SkillButton from '../SkillButton/SkillButton'

function SkillLegend({ className }) {
  return (
    <div className={className}>
      <div
        className="flex justify-center w-full py-2 px-2 text-xs bg-gray-100 text-gray-700 border-y border-gray-200"
        data-cy="skill-legend"
      >
        <p className="inline-flex items-center gap-1 px-2 font-medium leading-none">
          <SkillButton size={3} state="neutral" label="" className="mr-1" />
          Not Introduced
        </p>
        <p className="inline-flex items-center gap-1 px-2 font-medium leading-none">
          <SkillButton size={3} state="introduced" label="" className="mr-1" />
          Introduced
        </p>
        <p className="inline-flex items-center gap-1 px-2 font-medium leading-none">
          <SkillButton size={3} state="completed" label="" className="mr-1" />
          Completed
        </p>
      </div>
    </div>
  )
}

SkillLegend.propTypes = {
  className: PropTypes.string
}

export default SkillLegend
